<div *ngIf="content.title">
  <div class="skymiles-landing-page-upgrades">
    <div class="skymiles-landing-page-upgrades__header">
      <h3 class="skymiles-landing-page-upgrades__header__title">
        {{ content.title }}
      </h3>
      <a
        *ngIf="content.action.url"
        [href]="content.action.url"
        class="skymiles-landing-page-upgrades__header__action--url"
        (click)="onViewAllClick(content.action)"
      >
        {{ content.action.label }}
      </a>
    </div>

    <div
      [class]="
        'skymiles-landing-page-upgrades__container__cards--' +
        content.cards.length
      "
      class="skymiles-landing-page-upgrades__container"
    >
      <div
        *ngFor="let card of content.cards; let i = index"
        [class]="
          'skymiles-landing-page-upgrades__wrapper' +
          (card.tag ? '__tag ' : ' ') +
          'skymiles-landing-page-upgrades__wrapper__card-type--' +
          card.type
        "
        class="skymiles-landing-page-upgrades__wrapper"
      >
        <div
          [ngClass]="
            'skymiles-landing-page-upgrades__wrapper__left' +
            (card.tag ? '__tag' : '')
          "
        >
          <div
            *ngIf="!card.tag; else choiceBenefit"
            class="skymiles-landing-page-upgrades__wrapper__left__label"
          >
            {{ card.label }}
          </div>
          <ng-template #choiceBenefit>
            <div>
              <span
                class="skymiles-landing-page-upgrades__wrapper__left__tag__label"
              >
                {{ card.tag }}
              </span>
            </div>
          </ng-template>
          <div
            [ngClass]="
              'skymiles-landing-page-upgrades__wrapper__left__title' +
              (card.tag ? '__tag' : '')
            "
            class="skymiles-landing-page-upgrades__wrapper__left__title"
          >
            <div>
              <span>{{ card.title }}</span>
            </div>
            <a
              [href]="card.link.url"
              class="skymiles-landing-page-upgrades__wrapper__left__title__link-label"
              (click)="onUpgradeCardClick(card, i)"
            >
              {{ card.link.label }}
              <span class="sr-only">{{ card.title }}</span>
            </a>
          </div>
        </div>

        <div class="skymiles-landing-page-upgrades__wrapper__right">
          <img [alt]="card.image.alt" [src]="card.image.src" />
        </div>
      </div>
    </div>
  </div>
</div>
